import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualLeadsByPropertyType extends React.Component {
  constructor(props) {
    super(props);

    // Load property_type options from local storage
    const propertytypeOptions = reactLocalStorage.getObject(Constants.Model).property.fields.property_type.options;


    this.state = {
      propertyTypeSums: {},
      propertytypeOptions,  
    };
  }

  componentDidMount() {
    // Fetch data from the API
    IndividualSalesReportAPI.getIndividualPropertyByConfiguration(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
const {  propertytypeOptions } = this.state;
    const propertyTypeSums = {};
    propertytypeOptions.forEach(option => {
      propertyTypeSums[option.value] = 0;
    });

    // Fill in the actual values from the API data
    data.forEach(item => {
      const propertyType = [item.property_type];
      propertyType.map(type => {
         propertyTypeSums[type] += item.sum
         return null;
      })
    });
    this.setState({propertyTypeSums});
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const {  propertytypeOptions , propertyTypeSums } = this.state;

    // Create a record of sums for each property_type option, starting at 0


    // Calculate the total sum of all property_type values
    const totalSum = Object.values(propertyTypeSums).filter(Boolean).reduce((total, value) => total + value, 0);
    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Properties By Configuration Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Configuration</th>
                <th>Total Properties</th>
              </tr>
            </thead>
            <tbody>
              {propertytypeOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{propertyTypeSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            {/* Add Chart Component */}
            <ChartComponent progressSums={propertyTypeSums} progressOptions={propertytypeOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualLeadsByPropertyType);
